import { useEffect } from 'react';
import { onSessionExpired } from '@/config/api';
import { useAlertContext } from '@/contexts/alert.context';

export function useSessionExpired() {
  const { notify } = useAlertContext();

  useEffect(() => {
    const unsubscribe = onSessionExpired(() => {
      notify({
        title: 'Sessão expirada',
        message: 'Sua sessão expirou. Faça login novamente.',
        type: 'warning',
      });
    });

    return unsubscribe;
  }, [notify]);
}
